import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdminOrderItemCard from "./AdminOrderItemCard";

const StepOrderItems = ({
  formData,
  addItem,
  updateItem,
  removeItem,
  updateInternal,
  errors = {},
}) => {
  const { items, meta, internal = {} } = formData;
  const [expandedIndex, setExpandedIndex] = useState(items.length - 1);

  const handleAccordionToggle = (index) => {
    setExpandedIndex((prev) => (prev === index ? -1 : index));
  };

  const handleKitchenNotesChange = (e) => {
    updateInternal({ kitchenNotes: e.target.value });
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}>
        <Typography variant="subtitle1" fontWeight="bold">
          Order Items
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            addItem();
            setExpandedIndex(items.length); // Expand new item
          }}>
          Add Item
        </Button>
      </Box>

      {errors.items && (
        <Typography color="error" variant="body2" mb={1}>
          {errors.items}
        </Typography>
      )}

      <Grid container spacing={2}>
        {items.map((item, index) => (
          <Grid item xs={12} key={`${item._id}-${item.type}-${index}`}>
            <Accordion
              expanded={expandedIndex === index}
              onChange={() => handleAccordionToggle(index)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2" fontWeight="bold">
                  Item #{index + 1}: {item.displayName || item.type}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <AdminOrderItemCard
                  item={item}
                  meta={meta}
                  index={index}
                  updateItem={updateItem}
                  removeItem={removeItem}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </Grid>

      <Box mt={3}>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Kitchen Notes
        </Typography>
        <TextField
          multiline
          rows={3}
          fullWidth
          placeholder="Any special internal notes for the kitchen (not visible to customer)"
          value={internal.kitchenNotes || ""}
          onChange={handleKitchenNotesChange}
        />
      </Box>
    </Box>
  );
};

export default StepOrderItems;
